import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileIcon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ic_24/Profile",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.9999 2C9.37988 2 7.24988 4.13 7.24988 6.75001C7.24988 9.32002 9.25988 11.4 11.8799 11.49C11.9599 11.48 12.0399 11.48 12.0999 11.49C12.1199 11.49 12.1299 11.49 12.1499 11.49C12.1599 11.49 12.1599 11.49 12.1699 11.49C14.7299 11.4 16.7399 9.32002 16.7499 6.75001C16.7499 4.13 14.6199 2 11.9999 2Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M17.08 14.15C14.29 12.29 9.73997 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91997 20.59C8.31997 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z",
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgProfileIcon);
export default ForwardRef;
